// Core
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

// Components
import Discount from './discounts/';
//import AffiliateCashback from './affiliate-cashback/';
import AffiliatePartners from './affiliate-partners/';
import Partners from './partners/';

const Discounts = ({ userData }) => {
  const { path } = useRouteMatch();

  return (
  	<>
    	<Box>
		    <Switch>
				<Route path={`${path}/partners`} render={() => <Partners userData={userData} />} />
			    {/*<Route path={`${path}/affiliate`} render={() => <AffiliateCashback userData={userData} />} />*/}
					<Route path={`${path}/affiliate-partners`} render={() => <AffiliatePartners userData={userData} />} />
			    <Route path={`${path}`} render={() => <Discount userData={userData} />} />
			    <Redirect from={`${path}*`} to={`${path}`} />
			</Switch>
		</Box>

	</>
  );
};

export default Discounts;